import { render, staticRenderFns } from "./TestingOrganizationsStudentTable.vue?vue&type=template&id=1bc479b9&"
import script from "./TestingOrganizationsStudentTable.vue?vue&type=script&lang=ts&"
export * from "./TestingOrganizationsStudentTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports